module.exports = __webpack_public_path__ + "img/9788971996355.9084f27e.jpg";